import React from 'react';
import { Link } from 'react-router-dom';
import './CookiePolicyPage.scss';

const CookiePolicyPage: React.FC = () => {
  return (
    <div className="cookie-policy-page">
      <h1>Cookie Policy</h1>
      <p className="last-updated">Last updated: September,8, 2024</p>
      
      <section>
        <h2>1. Introduction</h2>
        <p>This Cookie Policy explains how Kitchen9 ("we", "our", or "us") uses cookies and similar technologies when you visit our website or use our services. By continuing to browse or use our services, you agree to our use of cookies as described in this policy.</p>
      </section>

      <section>
        <h2>2. What are Cookies?</h2>
        <p>Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to the owners of the site.</p>
      </section>

      <section>
        <h2>3. How We Use Cookies</h2>
        <p>We use cookies for the following purposes:</p>
        <ul>
          <li><strong>Essential Cookies:</strong> These are necessary for the website to function properly and cannot be switched off in our systems.</li>
          <li><strong>Analytical/Performance Cookies:</strong> These allow us to recognize and count the number of visitors and see how visitors move around our website when they are using it.</li>
          <li><strong>Functionality Cookies:</strong> These are used to recognize you when you return to our website, enabling us to personalize our content for you and remember your preferences.</li>
          <li><strong>Targeting Cookies:</strong> These record your visit to our website, the pages you have visited, and the links you have followed.</li>
        </ul>
      </section>

      <section>
        <h2>4. Types of Cookies We Use</h2>
        <ul>
          <li><strong>Session Cookies:</strong> These are temporary and expire when you close your browser.</li>
          <li><strong>Persistent Cookies:</strong> These remain on your device until you erase them or they expire.</li>
          <li><strong>First-Party Cookies:</strong> These are set by our website.</li>
          <li><strong>Third-Party Cookies:</strong> These are set by our trusted partners, such as analytics services.</li>
        </ul>
      </section>

      <section>
        <h2>5. Specific Cookies We Use</h2>
        <table>
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Purpose</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>session_id</td>
              <td>Maintains your session across page requests</td>
              <td>Session</td>
            </tr>
            <tr>
              <td>user_preferences</td>
              <td>Stores your dietary preferences and settings</td>
              <td>1 year</td>
            </tr>
            <tr>
              <td>_ga (Google Analytics)</td>
              <td>Used to distinguish users</td>
              <td>2 years</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>6. Managing Cookies</h2>
        <p>Most web browsers allow you to control cookies through their settings preferences. However, limiting the ability of websites to set cookies may worsen your overall user experience. To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">www.aboutcookies.org</a>.</p>
      </section>

      <section>
        <h2>7. Changes to This Cookie Policy</h2>
        <p>We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page and updating the "Last updated" date.</p>
      </section>

      <section>
        <h2>8. Contact Us</h2>
        <p>If you have any questions about this Cookie Policy, please <Link to="/contact">contact us</Link>.</p>
      </section>
    </div>
  );
};

export default CookiePolicyPage;